import moment from 'moment';
import { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import crossBlack from '../../../assets/img/icons/cross_black.svg';
import plusIcon from '../../../assets/img/icons/plus_white.svg';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import TimePicker from '../../../components/TimePicker';
import {
  ColoredButton,
  ColoredButtonWithIcon,
} from '../../../styledComponents/buttons';
import {
  FormAlert,
  InputLabel,
  InputWithLabelSection,
  RedStar,
} from '../../../styledComponents/common';

const MaxTaskDurationModal = ({
  isOpen,
  toggle,
  createMaxTaskDuration,
  isMaxTaskDurationLoading,
  maxTaskDurationInfo,
  clearMaxTaskTimeState,
  initialDuration
}) => {
  const [duration, setDuration] = useState(moment('00:00', 'HH:mm'));

  const handleTimeChange = value => {
    const start_time = value.replace(/ /g, '');
    setDuration(moment(start_time, 'h:mmA').format('HH:mm'));
  };

  useEffect(() => {
    if (maxTaskDurationInfo) {
      toggle(); // close modal

      setTimeout(() => {
        clearMaxTaskTimeState(); // only clears the info
      }, 0);
    }
  }, [maxTaskDurationInfo]);


  useEffect(() => {
    if (isOpen) {
      if (initialDuration) {
        // Convert hours to HH:MM format
        const hours = Math.floor(initialDuration);
        const minutes = Math.round((initialDuration - hours) * 60);
        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        setDuration(moment(timeString, 'HH:mm').format('HH:mm'));
      } else {
        setDuration(moment('00:00', 'HH:mm')); // reset on open
      }
    }
  }, [isOpen, initialDuration]);

  const timeMoment = moment(duration, 'HH:mm', true);

  const handleSave = () => {
    const hours = timeMoment.hours();
    const minutes = timeMoment.minutes();
    const totalHours = parseFloat((hours + minutes / 60).toFixed(2));

    // console.log('Saving Max Duration:', totalHours);
    const payload = {
      max_task_duration: totalHours,
    };

    createMaxTaskDuration(payload);
    toggle();
  };

  const isValid =
    timeMoment.isValid() &&
    (timeMoment.hours() !== 0 || timeMoment.minutes() !== 0);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{
        maxWidth: '500px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      {/* Cross Button */}
      <div
        style={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          cursor: 'pointer',
          zIndex: 1000,
        }}
      >
        <img
          src={crossBlack}
          alt="Close"
          onClick={toggle}
          style={{ width: '25px', height: '25px' }}
        />
      </div>

      <ModalBody style={{ padding: '40px 70px' }}>
        <h3 style={{ marginBottom: '20px' }}>Max Task Duration</h3>

        <InputWithLabelSection style={{ width: '200px', position: 'relative' }}>
          <InputLabel style={{ marginBottom: '10px' }}>
            Estimated Duration <RedStar>*</RedStar>
          </InputLabel>

          <TimePicker
            value={duration}
            onChange={value => handleTimeChange(value)}
          />

          <span
            style={{
              position: 'absolute',
              right: '-35px',
              top: '40px',
              pointerEvents: 'none',
              color: '#666',
            }}
          >
            Hrs
          </span>
        </InputWithLabelSection>

        {/* {!isValid && (
          <FormAlert style={{ marginTop: '10px' }}>
            Duration must be more than 00:00
          </FormAlert>
        )} */}

        <div style={{ marginTop: '30px', textAlign: 'right' }}>
          <ColoredButton
            onClick={handleSave}
            style={{
              opacity: !isValid || isMaxTaskDurationLoading ? 0.6 : 1,
              cursor:
                !isValid || isMaxTaskDurationLoading
                  ? 'not-allowed'
                  : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 25px',
            }}
            disabled={!isValid || isMaxTaskDurationLoading}
          >
            {isMaxTaskDurationLoading ? (
              <ButtonTextLoader color="#fff" loadingText="" size={4} />
            ) : (
              <>
                <img
                  src={plusIcon}
                  alt=""
                  style={{ width: '16px', height: '16px', marginBottom: '2px' }}
                />
                Save
              </>
            )}
          </ColoredButton>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MaxTaskDurationModal;
